import { jwtDecode } from 'jwt-decode'
import { jwtStorage } from './jwtStorage'
import { saveReturnTo } from './returnTo'

export function isJwtExpired(token: string | null): boolean {
  if (!token) return true
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token)
    if (!exp) return false
    return exp * 1000 <= Date.now()
  } catch {
    return true
  }
}

// null for anything that is not a JWT or carries no exp - provider tokens are often opaque
export function jwtExpiresAt(token?: string): string | null {
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token)
    return exp ? new Date(exp * 1000).toISOString() : null
  } catch {
    return null
  }
}

export function clearJwtAndRedirectToLogin(): void {
  jwtStorage.remove()
  saveReturnTo()
  window.location.replace(`${window.location.origin}/login`)
}
